import { motion } from 'framer-motion';
import { Dispatch, PropsWithChildren, SetStateAction } from 'react';

interface Props {
  readonly onCloseCallback?: Dispatch<SetStateAction<boolean>>;
  readonly className?: string;
}

const Backdrop = ({
  children,
  className,
  onCloseCallback,
}: PropsWithChildren<Props>) => (
  <motion.div
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    initial={{ opacity: 0 }}
    role="presentation"
    className={className}
    onClick={() => onCloseCallback?.((oldState: boolean) => !oldState)}
  >
    <div className="fixed bottom-0 left-0 right-0 top-0 bg-black-100/40">
      {children}
    </div>
  </motion.div>
);

export default Backdrop;
